import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/home',
    icon: 'fa fa-dashboard',
  },
  {
    name: 'Approval Pending',
    url: '/members',
    icon: 'fa fa-user',
    children: [
      {
        name: 'Coach',
        url: '/approval-pending/coach',
        icon: 'fa fa-user-circle',
      },
      {
        name: 'School',
        url: '/approval-pending/school',
        icon: 'fa fa-building',
      },
      {
        name: 'Athletic Director',
        url: '/approval-pending/athletic_director',
        icon: 'fa fa-building',
      },
    ],
  },
  {
    name: 'Members',
    url: '/members',
    icon: 'fa fa-user',
    children: [
      {
        name: 'Coach',
        url: '/members/coach',
        icon: 'fa fa-user-circle',
      },
      {
        name: 'School',
        url: '/members/school',
        icon: 'fa fa-building',
      },
      {
        name: 'Athletic Director',
        url: '/members/athletic-director',
        icon: 'fa fa-building',
      },
    ],
  },
  {
    name: 'Tournaments',
    url: '/tournaments',
    icon: 'fa fa-trophy',
  },
  {
    name: 'Schedules',
    url: '/schedules',
    icon: 'fa fa-calendar',
  },
  // MASTER LIST
  {
    name: 'Masters',
    url: '/master',
    icon: 'fa fa-asterisk',
    children: [
      {
        name: 'Sports',
        url: '/master/sports',
        icon: 'fa fa-futbol-o',
      },
      {
        name: 'Levels',
        url: '/master/levels',
        icon: 'fa fa-level-up',
      },
      {
        name: 'Ratings',
        url: '/master/ratings',
        icon: 'fa fa-star-half-o',
      },
      {
        name: 'Divisions',
        url: '/master/divisions',
        icon: 'fa fa-deviantart',
      },
      // {
      //   name: 'Schools',
      //   url: '/master/schools',
      //   icon: 'fa fa-building',
      // },
      {
        name: 'Tutorials',
        url: '/master/tutorials',
        icon: 'fa fa-video-camera',
      },
      {
        name: 'CIF',
        url: '/master/cif',
        icon: 'fa fa-futbol-o',
      },
    ],
  },
  // CMS
  {
    name: 'CMS',
    url: '/cms',
    icon: 'fa fa-file',
    children: [
      // HOME
      {
        name: 'Home',
        url: '/cms/home',
        icon: 'fa fa-home',
        children: [
          {
            name: 'Banner',
            url: '/cms/home/banner',
            icon: 'fa fa-caret-square-o-right',
          },
          {
            name: 'Middle Section',
            url: '/cms/home/middle-section',
            icon: 'fa fa-align-center ',
          },
          {
            name: 'Footer',
            url: '/cms/home/footer',
            icon: 'fa fa-hand-o-down',
          },
        ],
      },
      // HOW IT WORKS
      {
        name: 'How It Works',
        url: '/cms/how-it-works',
        icon: 'fa fa-podcast',
      },
      {
        name: 'About Us',
        url: '/cms/about-us',
        icon: 'fa fa-info-circle',
      },
      {
        name: 'Privacy Policy',
        url: '/cms/privacy-policy',
        icon: 'fa fa-lock',
      },
      {
        name: 'Terms & Condition',
        url: '/cms/terms-condition',
        icon: 'fa fa-question-circle',
      },
    ],
  },
  {
    name: 'Subscriptions Plans',
    url: '/subscriptions',
    icon: 'fa fa-credit-card',
    children: [
      {
        name: `Coach's Plans`,
        url: '/subscriptions/coach',
        icon: 'fa fa-credit-card',
      },
      {
        name: `School's Plans`,
        url: '/subscriptions/school',
        icon: 'fa fa-credit-card',
      },
    ],
  },
  {
    name: 'Transactions',
    url: '/transactions',
    icon: 'fa fa-usd',
    children: [
      {
        name: `Coach's Transactions`,
        url: '/transactions/coach',
        icon: 'fa fa-usd',
      },
      {
        name: `School's Transactions`,
        url: '/transactions/school',
        icon: 'fa fa-usd',
      },
    ],
  },
  {
    name: 'Discount Coupons',
    url: '/discount-coupons',
    icon: 'fa fa-percent',
  },
  {
    name: 'Email Template',
    url: '/email-template',
    icon: 'fa fa-envelope',
  },
  {
    name: 'Contacts',
    url: '/contacts',
    icon: 'fa fa-user-circle',
  },
  {
    name: 'Setting',
    url: '/setting',
    icon: 'fa fa-gear',
  },
];
